<template>
  <div class="min-h-screen flex bg-gray-50">
    <SideBar />
    <main class="flex-grow p-6">
      <h1 class="text-2xl font-bold">
        Help & Support
      </h1>
      <p class="mt-2 text-gray-700">
        Quick links to internal standards and guides.
      </p>
      <p
        v-if="!authStore.isAuthenticated"
        class="mt-2 text-sm text-gray-600"
      >
        Please log in to see links and resources. Login requires a PerByte Accelo Account.
      </p>

      <div
        v-else
        class="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
      >
        <a
          v-for="resource in resources"
          :key="resource.title"
          :href="resource.url"
          target="_blank"
          rel="noreferrer"
          class="group rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:-translate-y-0.5 hover:border-cerulean hover:shadow-md"
        >
          <div class="text-sm text-gray-500">{{ resource.category }}</div>
          <div class="mt-2 text-base font-semibold text-gray-900 group-hover:text-cerulean">
            {{ resource.title }}
          </div>
          <div class="mt-3 text-xs text-gray-500">SharePoint</div>
        </a>
      </div>
    </main>
  </div>
</template>

<script>
import { useAuthStore } from '@/pinia/authStore'
import SideBar from '@/ReusableComponents/SideBar.vue'

export default {
  name: 'HelpPage',
  components: { SideBar },
  setup() {
    const authStore = useAuthStore()
    return { authStore }
  },
  data() {
    return {
      resources: [
        {
          title: 'Staff Expectations for Ticket Management',
          category: 'Ticketing',
          url: 'https://perbyteinc.sharepoint.com/:w:/r/sites/PerByte2/_layouts/15/Doc.aspx?sourcedoc=%7B87667C13-CB68-4583-B3E1-72D3DB9804F3%7D&file=Staff%20Expectations%20for%20Ticket%20Management.docx&action=default&mobileredirect=true&DefaultItemOpen=1'
        },
        {
          title: 'Client .Net Assembly Versioning Standards',
          category: 'Development Standards',
          url: 'https://perbyteinc.sharepoint.com/:u:/s/DevTeam/IQABxwwsa8q4R6_0TUJc_6KVATWKk2iXhjuZqVla7ehv8YM?e=ifUF8B'
        },
        {
          title: 'Client Assembly Naming Standard',
          category: 'Development Standards',
          url: 'https://perbyteinc.sharepoint.com/:u:/s/DevTeam/IQB_5w-qT-2RRKh5NILsFtIAAfdPqgta80Je1RTi-jPnq0I?e=bxSGeI'
        },
        {
          title: 'Dev Log Guide',
          category: 'Development Standards',
          url: 'https://perbyteinc.sharepoint.com/:w:/s/DevTeam/IQBG70JLO7fuQ7sn_lxr_cleAfDgo8j4wYd0Wh03UMpc-MM?e=p6iXs4'
        },
        {
          title: 'Development Standard',
          category: 'Development Standards',
          url: 'https://perbyteinc.sharepoint.com/:w:/s/DevTeam/IQBG70JLO7fuQ7sn_lxr_cleAfDgo8j4wYd0Wh03UMpc-MM?e=p6iXs4'
        },
        {
          title: 'Aptify Naming Conventions',
          category: 'Development Standards',
          url: 'https://perbyteinc.sharepoint.com/:w:/s/DevTeam/IQDao__zabFiSZ4rFiO33d7sAfEgMszz2bXDypZNwV4hhoQ?e=smYl8q'
        },
        {
          title: 'SQL Standards',
          category: 'Development Standards',
          url: 'https://perbyteinc.sharepoint.com/:w:/s/DevTeam/IQDCewg1699EQaH3D4Y5faaBAeqchZm0X7bqYcwbKCxJwn8?e=hmuqMI'
        }
      ]
    }
  }
}
</script>
